<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row class="justify-center align-center fill-height">
      <div class="text-center">
        <v-icon size="50">
          mdi-alert-circle
        </v-icon>
        <p class="mt-4">登入時發生錯誤，請重試。</p>
        <v-btn @click="retry">重試</v-btn>
      </div>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
const retry = () => window.location.reload();
</script>
